import React from 'react'
import { Button, Paper, Stack, Text, Title } from '@mantine/core'
import Badges from './Badges'
import { Link } from 'react-router'

/**
 * Renders a list of recent jobs.
 * @param {object[]} jobPostings The landing page to load jobs from.
 * @param {string} color the color to use in this component.
 * @returns {JSX.Element}
 */
export default function RecentJobs ({ jobPostings, color }) {
  return (
    <Stack>
      <Title order={3} c='gray.8'>Recent Jobs</Title>
      {jobPostings.map(jobPosting => <RecentJob key={jobPosting.identifier} jobPosting={jobPosting} color={color}/>)}
    </Stack>
  )
}

/**
 * Renders a recent job row.
 * @param {object} jobPosting The job post.
 * @param {string} color The text link color.
 * @returns {JSX.Element}
 */
function RecentJob ({ jobPosting, color }) {
  return (
    <Paper key={jobPosting.identifier}>
      <Stack align='flex-start' gap='xs'>
        <Button
          size='md'
          variant='transparent'
          color={color}
          p={0}
          component={Link}
          to={`../${jobPosting.identifier}`}
        >
          {jobPosting.title}
        </Button>
        <Badges jobPosting={jobPosting} compact={true} />
        <Text c='gray.8' size='md'>{jobPosting.location}</Text>
      </Stack>
    </Paper>
  )
}
